import { BaseApiService } from '../../../api/base';
import type {
  RequestAppLinkRequest,
  RequestAppLinkResponse,
  RequestOtpCodeRequest,
  RequestOtpCodeResponse,
  SignUpByOtpCodeRequest,
  SignUpByOtpCodeResponse,
} from '../types/auth';

class AuthApiService extends BaseApiService {
  async requestOtpCode(
    request: RequestOtpCodeRequest
  ): Promise<RequestOtpCodeResponse> {
    return this.post<RequestOtpCodeResponse>('/auth/otp/request', request);
  }

  async signUp(
    request: SignUpByOtpCodeRequest
  ): Promise<SignUpByOtpCodeResponse> {
    return this.post<SignUpByOtpCodeResponse>('/auth/otp/signup', request);
  }

  async requestAppDownloadLink(
    request: RequestAppLinkRequest
  ): Promise<RequestAppLinkResponse> {
    return this.post<RequestAppLinkResponse>(
      '/auth/otp/request-app-link',
      request
    );
  }
}

export const authApiService = new AuthApiService();
